import React from 'react';
import { InstagramIcon } from 'lucide-react';
interface Sponsor {
  name: string;
  handle: string;
  logo: string;
  url: string;
  description: string;
}
const sponsors: Sponsor[] = [{
  name: 'Dra. Ysailis Martínez',
  handle: '@draysailismartinez',
  description: 'Obstetricia & Ginecología',
  logo: 'https://cdn.magicpatterns.com/uploads/eK1tz1n23C2463rDBBe4QN/logo_Dra_Ysalismar.png',
  url: 'https://instagram.com/draysailismartinez'
}, {
  name: 'Centro Médico Especializado Profem',
  handle: '@profemm.ccs',
  description: 'Salud integral femenina',
  logo: 'https://cdn.magicpatterns.com/uploads/kNUGAuQnAtfu82bKExsLdE/Logo_Centro_medico_Especializado_Profem.jpg',
  url: 'https://instagram.com/profemm.ccs'
}];
interface SponsorsSectionProps {
  variant?: 'strip' | 'full';
}
export function SponsorsSection({
  variant = 'full'
}: SponsorsSectionProps) {
  if (variant === 'strip') {
    return <section className="py-10 bg-cream border-y border-beige" data-id="element-237">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
          <p className="text-center text-xs font-body font-bold text-taupe-light uppercase tracking-[0.2em] mb-6" data-id="element-239">
            Respaldado por profesionales de la salud
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16" data-id="element-240">
            {sponsors.map(sponsor => <a key={sponsor.name} href={sponsor.url} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 transition-opacity hover:opacity-80" aria-label={`Visitar Instagram de ${sponsor.name}`} data-id="element-241">
                <img src={sponsor.logo} alt={`Logo de ${sponsor.name}`} className="h-12 sm:h-14 w-auto object-contain" data-id="element-242" />
                <div className="text-left" data-id="element-243">
                  <p className="font-heading text-sm font-bold text-taupe leading-tight" data-id="element-244">
                    {sponsor.name}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-body text-taupe-light group-hover:text-gold transition-colors" data-id="element-245">
                    <InstagramIcon className="w-3 h-3" data-id="element-246" />
                    {sponsor.handle}
                  </span>
                </div>
              </a>)}
          </div>
        </div>
      </section>;
  }
  return <section className="py-20 bg-beige-light" data-id="element-247">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="text-center mb-12" data-id="element-249">
          <span className="inline-block px-4 py-1 rounded-full bg-gold/10 text-gold text-sm font-body tracking-widest uppercase mb-4" data-id="element-250">
            Avalado por
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-251">
            Profesionales que respaldan este método
          </h2>
          <p className="text-lg text-taupe-light font-body max-w-2xl mx-auto" data-id="element-252">
            Construido en colaboración con especialistas en salud femenina y
            ginecología.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-253">
          {sponsors.map(sponsor => <a key={sponsor.name} href={sponsor.url} target="_blank" rel="noopener noreferrer" className="group bg-cream rounded-2xl p-8 shadow-soft border border-beige flex flex-col items-center text-center hover:-translate-y-1 hover:shadow-lg transition-all duration-300" aria-label={`Visitar Instagram de ${sponsor.name}`} data-id="element-254">
              <div className="w-32 h-32 flex items-center justify-center mb-6 bg-white rounded-2xl p-3" data-id="element-255">
                <img src={sponsor.logo} alt={`Logo de ${sponsor.name}`} className="max-w-full max-h-full object-contain" data-id="element-256" />
              </div>
              <h3 className="font-heading text-xl font-bold text-taupe mb-1" data-id="element-257">
                {sponsor.name}
              </h3>
              <p className="font-body text-sm text-taupe-light mb-4" data-id="element-258">
                {sponsor.description}
              </p>
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/10 text-gold font-body text-sm font-bold group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-259">
                <InstagramIcon className="w-4 h-4" data-id="element-260" />
                {sponsor.handle}
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}